module.exports = __webpack_public_path__ + "img/bg-top.4bea6a1c.png";